import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DomainService } from '../../redux/domain/service/domain.service';
import { CurrentContextService } from '../../redux/current-context/service/current-context.service';
import { NxI18nService } from '../../ui/nxI18nPipe/nxI18n.service';

@Injectable({
    providedIn: 'root'
})
export class AppHeadTitleAndIconService {
    constructor(  private titleService: Title,
                  private translateService: TranslateService,
                  private domainService: DomainService,
                  private currentContextService: CurrentContextService,
                  private nxI18nService : NxI18nService) {
    }

    public setAppTitleAndIconFromUrl( pageUrl: string, detailLabel ?: string ) {

        const isWorkflow: boolean = pageUrl.includes('/workflow');
        let domLabel ='?';
        const currentDomain = this.domainService.getCurrentDomain();
        if(!!currentDomain) {
            domLabel = currentDomain.label;
        }

        if (isWorkflow) {
             if ( pageUrl.includes('/tasks/') ) {
                 if (!detailLabel) {
                     detailLabel = this.translateService.instant('PAGE_TITLE.task')+' ...';
                 }
                 if ( pageUrl.includes('/details')) {
                   // détail d'une tâche
                   this.titleService.setTitle( detailLabel +' - '+ domLabel + ' - Nexia');
                 } else if (pageUrl.includes('/comment')) {
                     const commentLabel = this.translateService.instant('PAGE_TITLE.comment');
                     this.titleService.setTitle( detailLabel +' / ' + commentLabel + ' - '+ domLabel + ' - Nexia');
                 } else if (pageUrl.includes('/histo')) {
                     const histoLabel = this.translateService.instant('PAGE_TITLE.histo');
                     this.titleService.setTitle( detailLabel +' / ' + histoLabel + ' - '+ domLabel + ' - Nexia');
                 } else if (pageUrl.includes('/info')) {
                     const infoLabel = this.translateService.instant('PAGE_TITLE.info');
                     this.titleService.setTitle( detailLabel +' / ' + infoLabel + ' - '+ domLabel + ' - Nexia');
                 }
                 else {
                   this.titleService.setTitle( detailLabel +' - '+ domLabel + ' - Nexia');
                 }
            }
            else if (pageUrl.includes('/search')) {
                 // liste des tâches
                 this.titleService.setTitle( this.translateService.instant( 'PAGE_TITLE.search_tasks' ) + ' - ' + domLabel + ' - Nexia' );
             } else if(pageUrl.includes('/supervision'))
                 {
                     this.titleService.setTitle( this.translateService.instant( 'PAGE_TITLE.supervision' ) + ' - ' + domLabel + ' - Nexia' );
                 }
        }
        else if (pageUrl.includes('/entities/')) {
                if (!detailLabel) {
                    detailLabel = this.translateService.instant('PAGE_TITLE.entity')+' ...';
                }
                if ( pageUrl.includes('/details')) {
                    // détail d'une entité
                    this.titleService.setTitle( detailLabel +' - '+ domLabel + ' - Nexia');
                } else if (pageUrl.includes('/comment')) {
                    const commentLabel = this.translateService.instant('PAGE_TITLE.comment');
                    this.titleService.setTitle( detailLabel +' / ' + commentLabel + ' - '+ domLabel + ' - Nexia');
                } else if (pageUrl.includes('/attachments')) {
                    const commentLabel = this.translateService.instant('PAGE_TITLE.attachments');
                    this.titleService.setTitle( detailLabel +' / ' + commentLabel + ' - '+ domLabel + ' - Nexia');
                }
                else if (pageUrl.includes('/histo')) {
                    const histoLabel = this.translateService.instant('PAGE_TITLE.histo');
                    this.titleService.setTitle( detailLabel +' / ' + histoLabel + ' - '+ domLabel + ' - Nexia');
                } else if (pageUrl.includes('/info')) {
                    const infoLabel = this.translateService.instant('PAGE_TITLE.info');
                    this.titleService.setTitle( detailLabel +' / ' + infoLabel + ' - '+ domLabel + ' - Nexia');
                }

                else if ( pageUrl.includes('/search')) {
                { // recherche d'entité
                    const currentEntityType : string = this.currentContextService.getCurrentEntityType();
                    if ( !!currentEntityType) {
                        const currentEntityTypeLabel: string = this.nxI18nService.instant('entity_type', currentEntityType, ['plural', 'singular'])
                        this.titleService.setTitle( this.translateService.instant('PAGE_TITLE.search_entities_among') +' : ' + currentEntityTypeLabel +  ' - '+ domLabel + ' - Nexia');
                    } else {
                        this.titleService.setTitle( this.translateService.instant('PAGE_TITLE.search_entities') +' - '+ domLabel + ' - Nexia');
                    }
                }
            }
        }
        else if (pageUrl.includes('/documents/')) {
            if (!detailLabel) {
                detailLabel = this.translateService.instant('PAGE_TITLE.doc')+' ...';
            }
            if ( pageUrl.includes('/details')) {
                // détail d'un document
                this.titleService.setTitle( detailLabel +' - '+ domLabel + ' - Nexia');
            } else if (pageUrl.includes('/comment')) {
                const commentLabel = this.translateService.instant('PAGE_TITLE.comment');
                this.titleService.setTitle( detailLabel +' / ' + commentLabel + ' - '+ domLabel + ' - Nexia');
            } else if (pageUrl.includes('/attachments')) {
                const commentLabel = this.translateService.instant('PAGE_TITLE.attachments');
                this.titleService.setTitle( detailLabel +' / ' + commentLabel + ' - '+ domLabel + ' - Nexia');
            }

            else if (pageUrl.includes('/histo')) {
                const histoLabel = this.translateService.instant('PAGE_TITLE.histo');
                this.titleService.setTitle( detailLabel +' / ' + histoLabel + ' - '+ domLabel + ' - Nexia');
            } else if (pageUrl.includes('/info')) {
                const infoLabel = this.translateService.instant('PAGE_TITLE.info');
                this.titleService.setTitle( detailLabel +' / ' + infoLabel + ' - '+ domLabel + ' - Nexia');
            }
        }
        else if (pageUrl.includes('/search')) {
            // recherche des documents
            this.titleService.setTitle(this.translateService.instant('PAGE_TITLE.search_documents') +' - '+ domLabel +' - Nexia');
        }
        else if (pageUrl.includes('/indexation')) {
            if (pageUrl.includes('/indexation/teams/new')) {
                // nouvelle équipe
                this.titleService.setTitle( this.translateService.instant('PAGE_TITLE.indexation_teams_new') + ' - Nexia');
            }
            else if (pageUrl.includes('/indexation/teams')) {
                // équipes
                this.titleService.setTitle( this.translateService.instant('PAGE_TITLE.indexation_teams') + ' - Nexia');
            }
            else if (pageUrl.includes('/indexation/')) {
                // draft créé, création de doc en cour, ou indexation/new : nouveau draft
                this.titleService.setTitle( this.translateService.instant('PAGE_TITLE.indexation_new') + ' - Nexia');
            }
            else {
                // page des indexations en cours
                this.titleService.setTitle( this.translateService.instant('PAGE_TITLE.indexation') + ' - Nexia');
            }
        }
        else if (pageUrl.includes('/support')) {
            let supportLabel: string  = this.translateService.instant('PAGE_TITLE.support');
            if (pageUrl.includes('/logs')) {
                supportLabel += ' : Logs';
            } else if (pageUrl.includes('/builds')) {
                supportLabel += ' : Builds';
            } else if (pageUrl.includes('/piper')) {
                supportLabel += ' : Piper';
            } else if (pageUrl.includes('/diskspace')) {
                supportLabel += ' : Disk space';
            }
            this.titleService.setTitle( supportLabel + ' - Nexia');
        }
        else {
            this.titleService.setTitle('Nexia')
        }

        // gestion d'affichage de l'icône Workflow ou Nexia ( par défaut )
        if ( isWorkflow ) {
            this.changeFavicon('assets/favicon2.ico');
        } else {
            this.changeFavicon('assets/favicon2.ico');
        }
    }

    private changeFavicon(iconUrl: string) {
        const link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
        if (link) {
            link.href = iconUrl;
        }
    }
}